<template>
	<b-modal
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
		:title="`Send email` | translate"
	>
		<form action="." method="post" class="text-center">
			<input
				type="text"
				class="form-control mb-3"
				v-model="input"
				:placeholder="'Subject' | translate"
			/>
			<textarea
				v-model="body"
				class="form-control mb-3"
				:placeholder="'Message' | translate"
			></textarea>
			<button class="btn btn-primary" @click.prevent="sendEmail">
				{{ 'Send' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
export default {
	name: 'modal-email',
	data() {
		return {
			input: '',
			body: '',
		}
	},
	props: ['show'],
	computed: {
		type() {
			return this.$store.state.modalType
		},
	},
	methods: {
		sendEmail() {
			this.axios({
				method: 'post',
				url: 'users/sendmail',
				data: {
					subject: this.input,
					body: this.body,
					to: this.$store.state.modalId,
				},
			}).then(response => {
				this.$emit('close')
			})
		},
	},
}
</script>
